import { ScrollbarBehaviourDirect } from "./ScrollbarBehaviourDirect.js";
import { ScrollbarBehaviourIndex } from "./ScrollbarBehaviourIndex.js";
import { ScrollbarBehaviourPureIndex } from "./ScrollbarBehaviourPureIndex.js";

export class ScrollbarBehaviour {
    public static INDEX = new ScrollbarBehaviourIndex();
    public static PURE_INDEX = new ScrollbarBehaviourPureIndex();
    public static DIRECT = new ScrollbarBehaviourDirect();
}